import { render } from "./IdentifyTop.vue?vue&type=template&id=15a52ad4&scoped=true"
import script from "./IdentifyTop.vue?vue&type=script&lang=js"
export * from "./IdentifyTop.vue?vue&type=script&lang=js"

import "./IdentifyTop.vue?vue&type=style&index=0&id=15a52ad4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a52ad4"]])

export default __exports__